import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
const Container = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: flex-start;
`;
const BarTrack = styled.div `
  width: 100%;
  height: 30px;
  background-color: ${({ theme }) => theme.greyLightMedium};
`;
const BarIndicator = styled.div `
  width: ${({ currentValue }) => currentValue}%;
  height: 40px;
  position: absolute;
  background-color: ${({ theme, color }) => (color ? color : theme.primaryRed)};
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 1s;
`;
export const BarChart = ({ initialValue = 0, newValue = 99, initiateAnimation = true, color = undefined, }) => {
    const [currentValue, setNewValue] = useState(initialValue);
    const updateValueToAnimate = () => setNewValue(newValue);
    useEffect(() => {
        if (initiateAnimation) {
            updateValueToAnimate();
        }
    }, [initiateAnimation]);
    return (React.createElement(Container, null,
        React.createElement(BarTrack, null),
        React.createElement(BarIndicator, { className: "chart-indicator", currentValue: currentValue, color: color })));
};
